import React, { Component } from 'react';
import pathWorkService from './PathWorkService';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { FormGroup, Form, Label, Input, Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { HuePicker, SketchPicker } from 'react-color';

class PathWorkAddPlain extends Component {

	constructor(props) {
		super(props);
		this.state = {
			
		};
	}

	componentDidMount() {
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/pathworks');
	}

	handleValidSubmit = (event, values) => {
		const { history } = this.props;
		let postvalues = values;
		(async () => {
			await pathWorkService.add(postvalues);
			history.push('/pathworks');
		})();
	}
	
	render() {
		const { t, i18n } = this.props;
		return (
			<AvForm onValidSubmit={this.handleValidSubmit}>
				<AvField name="state" label={t('State')} required errorMessage={t('FieldInvalid')} validate={{
					required: { value: true, errorMessage: t('FieldRequired') },
					minLength: { value: 2 }
				}} />
				<FormGroup>
					<Button>Save</Button>&nbsp;
					<Button onClick={this.handleClickCancel}>Cancel</Button>
				</FormGroup>
			</AvForm>
		);
	}
}

export const PathWorkAdd = withTranslation()(PathWorkAddPlain);
